import { useState } from 'react'
import ModalWindow from './ModalWindow'
import { WechatOutlined, WechatWorkOutlined } from '@ant-design/icons'
import { Flex, FloatButton } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { toggleModal } from 'slices/modal.slice'
import useScopes from 'hooks/useScopes'


const FloatingChat = ({ showOnTop }) => {
  const [hovered, setHovered] = useState(false)
  const dispatch = useDispatch()
  const { isAdmin } = useScopes()
  // const [visible, setVisible] = useState(false)
  const visible = useSelector((state) => state.modalSlices.visible)

  return (
    !isAdmin && <>
   <Flex>
      <ModalWindow
        visible={visible}
        close={() => dispatch(toggleModal())}
        second={showOnTop}
      />
      <Flex
        onClick={() => dispatch(toggleModal())}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <Flex>
          <FloatButton
            icon={<WechatOutlined />}
            type="default"
            style={{
              right: 35,
              bottom: showOnTop ? undefined : 100,
            }}
          />
        </Flex>
      </Flex>
    </Flex>
    </>
  )
}

export default FloatingChat
